export function setToken(token) {
    return localStorage.setItem("admin_token", token);
}

export function getToken() {
    return localStorage.getItem("admin_token")
}

export function removeToken() {
    return localStorage.removeItem("admin_token")
}